"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Item = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _ButtonListItem = _interopRequireDefault(require("./ButtonListItem"));

var _elements = require("../../styles/elements");

var _ButtonList = require("./ButtonList.styles");

var Item = (0, _base["default"])("li", {
  target: "extxvb00",
  label: "Item"
})("button{border-color:", function (_ref) {
  var active = _ref.active,
      theme = _ref.theme;
  return active && theme.color.buttonPrimary.borderHover;
}, ";}");
exports.Item = Item;

var ButtonList = function ButtonList(_ref2) {
  var className = _ref2.className,
      listProp = _ref2.list,
      selected = _ref2.selected,
      onSelect = _ref2.onSelect,
      size = _ref2.size;
  return (0, _jsxRuntime.jsx)("ul", {
    css: [_elements.list.styles.preflight, _ButtonList.styles[size], process.env.NODE_ENV === "production" ? "" : ";label:ButtonList;"],
    className: className,
    children: listProp.map(function (_ref3) {
      var type = _ref3.type,
          title = _ref3.title,
          icon = _ref3.icon,
          name = _ref3.name,
          btnType = _ref3.btnType;
      return (0, _jsxRuntime.jsx)(_ButtonListItem["default"], {
        active: selected === type,
        icon: icon,
        name: name,
        onSelect: onSelect,
        type: type,
        size: size,
        title: title,
        btnType: btnType
      }, type);
    })
  });
};

ButtonList.propTypes = {
  className: _propTypes.string,
  list: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    type: _propTypes.string,
    title: _propTypes.string,
    icon: _propTypes.node,
    name: _propTypes.string
  })),
  onSelect: _propTypes.func,
  selected: _propTypes.string,
  size: (0, _propTypes.oneOf)(['big', 'small'])
};
ButtonList.defaultProps = {
  className: undefined,
  list: [],
  onSelect: function onSelect() {},
  selected: undefined,
  size: 'small'
};
var _default = ButtonList;
exports["default"] = _default;
//# sourceMappingURL=ButtonList.js.map